// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box-body .col-md-12[data-v-61aab6af]:not(.no-remove){padding:0;margin:0 0 10px 0}.box[data-v-61aab6af]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
